import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from 'pinia';
import './theme/color.less';
import 'vant/lib/index.css';
import Vant from 'vant';
import { i18n } from '@/utils/i18n';
import SvgIcon from '@/components/SvgIcon.vue';
import '@/assets/iconfont/iconfont.js';

// 移动端调试工具 vconsole，仅开发环境下引入
if (process.env.NODE_ENV === 'development') {
  import('vconsole').then((VConsole) => {
    // eslint-disable-next-line
    new VConsole.default();
  });
}

createApp(App)
  .use(createPinia())
  .use(router)
  .use(Vant)
  .use(i18n)
  .component('SvgIcon', SvgIcon)
  .mount('#app');
